const MAX_EMAIL_LENGTH = 50;

const EmailHelper = {
  emailIsValid: (emailFormField) => {
    const value = emailFormField.value || emailFormField;

    // Normal validation check
    if (typeof emailFormField.checkValidity === 'function' && !emailFormField.checkValidity()) {
      return false;
    }

    return EmailHelper.validateEmail(value);
  },
  validateEmail: (value) => {
    // Check if email is too long
    if (value.length > MAX_EMAIL_LENGTH) {
      return false;
    }

    return !!value.match(
      /^\.?[a-zA-Z0-9!#$%&'*=?^_+`{|}~/-]+[a-zA-Z0-9!#$%&'*=?^_+`{|}~/.-]*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9-]+$/
    );
  },
};

export default EmailHelper;
